/*
 * Author: Harper Yan
 * File Created: Tuesday, 24-07-16 11:14 am
 * Last Modified: Tuesday, 24-07-23 03:33 pm, by Harper Yan
 */

import type { StyledComponent } from '@emotion/styled';

import type { LinkProps, TypographyProps } from '@mui/material';
import { Link, styled, Typography } from '@mui/material';

export const StyledLink: StyledComponent<LinkProps> = styled(Link)(() => ({
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '20px',
  textAlign: 'center',
  color: '#707A8A',
}));

export const StyledLastItem: StyledComponent<TypographyProps> = styled(
  Typography
)(() => ({
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '20px',
  textAlign: 'center',
  color: '#FFFFFF',
}));
